import axios from 'axios'

export function request(config) {
  const instance = axios.create({
    baseURL: 'https://kpc.cowsms.com/webapi',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      // 'Testk': 'Tsp8EyAypFN7cY3M8weWbbgsW5ktRzzz'
    },
    // headers: { 'Authorization': 'Bearer 2903|eeD8gMubWJrxvyXBUUWu1NVgbdCuLYgWJfb5h4zupPQkvmYsQPlb5QM6HeYxJNs6xJm8jzHmTUi90wew' },
    timeout: 5000,
  })
  // instance.interceptors.request.use(config => {
  //   return config
  // }, err => {
  // })
  instance.interceptors.response.use(res => {
    return res.data
  }, err => {
    if (err.response.status === 401) {
      let currentUrl = window.location.href;
      window.location.href = "https://kpc.cowsms.com/wechat/oauth?redirect_url=" + encodeURIComponent(window.location.href);
      return
    }
  })
  return instance(config)
}

export function requestBanling(config) {
  const instance = axios.create({
    baseURL: '//weixin.ibanling.com/api',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    timeout: 5000,
  })
  instance.interceptors.response.use(res => {
    return res.data
  }, err => {

  })
  return instance(config)
}